import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import Grid from '@mui/material/Grid';
import { useMediaQuery } from 'react-responsive';
import * as Config from '../../Config/environment';

import {
  maskCreditcard,
  maskCardExpiry,
  maskCPF,
  validarNumeroCartao,
  validarValidadeCartao,
  validarNomeCartao,
  tokenizarCartao,
  getCardBrand,
  validarCPF
} from '../../Components/Utils';

import iconVisa from '../../Assets/Images/creditcard/visa.svg';
import iconMastercard from '../../Assets/Images/creditcard/mastercard.svg';
import iconAmex from '../../Assets/Images/creditcard/amex.svg';
import iconDefaultCreditcard from '../../Assets/Images/creditcard/default.svg';
import iconElo from '../../Assets/Images/creditcard/elo.svg';
import iconHipercard from '../../Assets/Images/creditcard/hipercard.svg';
import iconDiscover from '../../Assets/Images/creditcard/discover.svg';
import iconDiners from '../../Assets/Images/creditcard/diners.svg';
import iconJcb from '../../Assets/Images/creditcard/jcb.svg';

const cardIcons = {
  visa: iconVisa,
  mastercard: iconMastercard,
  amex: iconAmex,
  elo: iconElo,
  hipercard: iconHipercard,
  discover: iconDiscover,
  diners: iconDiners,
  jcb: iconJcb,
  default: iconDefaultCreditcard
};

const CreditCardModal = ({
  visible,
  onHide,
  onSuccess,
  cardToEdit = null,
  createCompanyCreditcard,
  updateCompanyCreditcard,
  setAlert,
  setAlertTitle,
  setAlertBody,
  showSuccessToast,
  showErrorToast,
  retrieveItemsList
}) => {


  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const [form, setForm] = useState({
    cardNumber: '',
    cardExpiry: '',
    cardCvv: '',
    cardHolderName: '', 
    cardHolderCpf: '',
    label: '',
    isMainCard: false,
    cardBrand: ''
  });

//   console.log('form |----------> '+JSON.stringify(form,null,2));

  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const scriptId = 'iugu-js-sdk';
    const existingScript = document.getElementById(scriptId);
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js.iugu.com/v2';
      script.async = true;
      script.onload = () => {
        if (window.Iugu) {
          window.Iugu.setAccountID(Config.IUGU_SETTINGS.accountId);
          window.Iugu.setTestMode(Config.IUGU_SETTINGS.testMode);
        }
      };
      script.onerror = () => console.error('[IUGU] Falha ao carregar script');
      document.body.appendChild(script);
    } else if (window.Iugu) {
        window.Iugu.setAccountID(Config.IUGU_SETTINGS.accountId);
        window.Iugu.setTestMode(Config.IUGU_SETTINGS.testMode);
    }
    return () => {
      const script = document.getElementById(scriptId);
      if (script) document.body.removeChild(script);
    };
  }, []);

useEffect(() => {
  if (visible) {
    if (cardToEdit) {
      setForm({ 
        label: cardToEdit.label || '', 
        isMainCard: cardToEdit.mainCreditcard === true,
        cardNumber: '',
        cardExpiry: '',
        cardCvv: '',
        cardHolderName: '',
        cardHolderCpf: '',
        cardBrand: ''
      });
    } else {
      setForm({
        cardNumber: '',
        cardExpiry: '',
        cardCvv: '',
        cardHolderName: '',
        cardHolderCpf: '',
        label: '',
        isMainCard: false,
        cardBrand: ''
      });
    }
  }
}, [visible, cardToEdit]);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {

    if (!form.label) {
      setAlertTitle("Campo obrigatório");
      setAlertBody("Informe um apelido para o cartão.");
      setAlert(true);
      return;
    }

    setSaving(true);

    if (cardToEdit) {
      updateCompanyCreditcard({
        creditcardId: cardToEdit.id,
        label: form.label,
        isMain: form.isMainCard ? 1 : 0
      }, {
        setSuccess: () => {
          showSuccessToast("Cartão atualizado", "Alterações salvas com sucesso.");
          retrieveItemsList();
          setSaving(false);
          onSuccess();
          onHide();
        },
        setError: (msg) => {
          showErrorToast("Erro ao atualizar cartão", msg);
          setSaving(false);
          setAlertTitle("Erro");
          setAlertBody(msg);
          setAlert(true);
        }
      });
    } else {


     if (!form.cardNumber || !form.cardExpiry || !form.cardCvv || !form.cardHolderName || !form.cardHolderCpf) {
        setAlertTitle("Campos obrigatórios");
        setAlertBody("Preencha todos os campos obrigatórios.");
        setAlert(true);
        setSaving(false);
        return;
      }

      if (!validarNumeroCartao(form.cardNumber)) {
        setAlertTitle("Número inválido");
        setAlertBody("O número do cartão informado é inválido.");
        setAlert(true); setSaving(false); return;
      }

      if (!validarValidadeCartao(form.cardExpiry)) {
        setAlertTitle("Validade inválida");
        setAlertBody("A validade do cartão está inválida.");
        setAlert(true); setSaving(false); return;
      }

      if (!validarNomeCartao(form.cardHolderName)) {
        setAlertTitle("Nome do titular inválido");
        setAlertBody("Informe o nome completo do titular do cartão. O nome deve ter no mínimo 3 caracteres.");
        setAlert(true); setSaving(false); return;
      }

      if (!validarCPF(form.cardHolderCpf)) {
        setAlertTitle("CPF inválido");
        setAlertBody("O CPF do titular do cartão é inválido.");
        setAlert(true); setSaving(false); return;
      }

      const [mes, ano] = form.cardExpiry.split('/');
      const cardData = {
        number: form.cardNumber.replace(/\D/g, ''),
        verification_value: form.cardCvv,
        first_name: form.cardHolderName.split(" ")[0],
        last_name: form.cardHolderName.split(" ").slice(1).join(" "),
        month: mes,
        year: '20' + ano
      };

      try {
        const token = await tokenizarCartao(cardData, setAlert, setAlertTitle, setAlertBody);
        const payload = {
          label: form.label,
          cardToken: token,
          isMain: form.isMainCard ? 1 : 0,
          cardHolderName: form.cardHolderName,
          cardHolderCpf: form.cardHolderCpf
        };

        createCompanyCreditcard(payload, {
          setSuccess: () => {
            showSuccessToast("Cartão salvo", "Cartão adicionado com sucesso.");
            retrieveItemsList();
            setSaving(false);
            onSuccess();
            onHide();
          },
          setError: (msg) => {
            showErrorToast("Erro ao salvar cartão", msg);
            setSaving(false);
          }
        });

      } catch (err) {
        console.error('Erro ao tokenizar:', err.message);
        setSaving(false);
      }
    }
  };

  return (
    <Dialog visible={visible} onHide={onHide} header={cardToEdit ? "Editar Cartão" : "Adicionar Cartão"} style={{ width: isMobile ? "100vw" : "60vw", height: isMobile ? "75vh" : "80vh",maxWidth: '700px' }} dismissableMask={false} closeOnEscape={false}>
      <Grid container spacing={2}>
        <Grid item xs={12}><label>Apelido do Cartão <span className="requiredField">*</span></label>
          <InputText value={form.label} onChange={(e) => handleChange('label', e.target.value)} className="w100" placeholder="Ex: Cartão da empresa" />
        </Grid>

        {!cardToEdit && <>
          <Grid item xs={12}><label>Número do cartão <span className="requiredField">*</span></label>
            <div style={{ position: 'relative' }}>
              <InputText value={form.cardNumber} onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, '');
                const masked = maskCreditcard(rawValue);
                handleChange('cardNumber', masked);
                handleChange('cardBrand', getCardBrand(rawValue));
              }} placeholder="**** **** **** ****" maxLength={form.cardBrand === 'amex' ? 18 : 19} className="w100" style={{ paddingRight: '3rem' }} />
              {form.cardBrand && <img src={cardIcons[form.cardBrand] || cardIcons.default} alt="bandeira" style={{ position: 'absolute', top: '5px', right: "5px", height: "30px" }} />}
              <small className="fLight">Não aceitamos cartões de crédito virtuais de uso único.</small>
            </div>
          </Grid>

          <Grid item xs={12}><label>Nome impresso no cartão <span className="requiredField">*</span></label>
            <InputText value={form.cardHolderName} onChange={(e) => handleChange('cardHolderName', e.target.value)} className="w100" placeholder="Exatamente como consta no cartão" />
          </Grid>

          <Grid item xs={6}><label>Validade <span className="requiredField">*</span></label>
            <InputText value={form.cardExpiry} onChange={(e) => handleChange('cardExpiry', maskCardExpiry(e.target.value))} maxLength={5} placeholder="MM/AA" className="w100" />
          </Grid>

          <Grid item xs={6}><label>CVV <span className="requiredField">*</span></label>
            <InputText 
                value={form.cardCvv} 
                type="text"
                onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, '');
                    const limit = form.cardBrand === 'amex' ? 4 : 3;
                    handleChange('cardCvv', raw.slice(0, limit));
                }} 
                placeholder="Código de segurança" className="w100" maxLength={form.cardBrand === 'amex' ? 4 : 3}
             />
          </Grid>
 
          <Grid item xs={12}><label>CPF do proprietário <span className="requiredField">*</span></label>
            <InputText value={form.cardHolderCpf} onChange={(e) => handleChange('cardHolderCpf', maskCPF(e.target.value))} placeholder="000.000.000-00" className="w100" />
          </Grid>
        </>}

        <Grid item xs={12} style={{marginTop:"1rem"}}><Checkbox inputId="isMainCard" checked={form.isMainCard} onChange={(e) => handleChange('isMainCard', e.checked)} /><label htmlFor="isMainCard" style={{ marginLeft: 8 }}>Definir como principal</label></Grid>

        <Grid item xs={12} className="flex-row justify-end" style={{ gap: '0.5rem' }}>
          <Button label="Cancelar" onClick={onHide} className="textButton" />
          <Button label="Salvar" loading={saving} onClick={handleSubmit} className="filledButton" />
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CreditCardModal;
